import { initializeUtagEvents } from './hotel_collapsible.analytics'

const BLOCK_WOC = '.hotel-woc'
const BLOCK_WOC_HEADER = '.hotel-woc__header'

export function initCollapsibles() {
  const collapsibles = document.querySelectorAll('.hotel-collapsible')

  collapsibles.forEach(collapsible => {
    const hasWOC = !!collapsible.querySelector(BLOCK_WOC)
    const header = collapsible.querySelector('.hotel-collapsible__summary-header')
    const button = collapsible.querySelector('.hotel-collapsible__summary-button')
    const summary = collapsible.querySelector('.hotel-collapsible__summary')
    const contentHeader = collapsible.querySelector('.hotel-collapsible__content-header')

    if (hasWOC) {
      collapsible.classList.add('hotel-collapsible--woc')

      const wocHeader = collapsible.querySelector(BLOCK_WOC_HEADER)
      if (wocHeader) {
        header.innerHTML = wocHeader.outerHTML

        const headerImage = header.querySelector('.hotel-woc__header-image .image')
        if (headerImage) {
          headerImage
            .querySelectorAll('source')
            .forEach(source => source.setAttribute('srcset', source.getAttribute('data-srcset')))
          headerImage.classList.add('loaded')
        }

        wocHeader.remove()
      }
      contentHeader?.remove()
    }

    collapsible.addEventListener('toggle', () => {
      const isOpen = collapsible.hasAttribute('open')

      if (summary) {
        summary.setAttribute('aria-expanded', isOpen.toString())
      }

      button?.classList.toggle('hotel-collapsible__summary-button--active', isOpen)

      if (isOpen) {
        initializeUtagEvents(button)
      }

      if (!hasWOC) {
        header?.classList.toggle('hotel-collapsible__summary-header--active', isOpen)
        contentHeader?.classList.toggle('hidden', !isOpen)
      }
    })
  })
}

initCollapsibles()
